/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from '../../../message';
import { IDescriptorBody } from '../../../descriptor';

export interface IReopenCommentThreadMessage extends IMessage {
	commentThreadId: string;
	documentId: string;
}

export default class ReopenCommentThreadMessage extends Message {
	public static readonly TYPE: string = '141';

	public static readonly READABLE_TYPE_NAME: string = 'reopenCommentThread';

	public static readonly DESCRIPTOR_NAME: string = 'CommentsV2ReopenCommentThreadMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			commentThreadId: {
				type: 'string',
				id: 1
			},
			documentId: {
				type: 'string',
				id: 2
			}
		}
	};

	public constructor(
		public readonly commentThreadId: string,
		public readonly documentId: string
	) {
		super();
	}

	public toJSON(): IReopenCommentThreadMessage {
		return {
			documentId: this.documentId,
			commentThreadId: this.commentThreadId
		};
	}

	public static fromJSON( object: IReopenCommentThreadMessage ): ReopenCommentThreadMessage {
		return new ReopenCommentThreadMessage(
			object.commentThreadId,
			object.documentId
		);
	}
}
